import React, { FC, ReactElement } from 'react'
import { ICellRendererParams } from 'ag-grid-community'
import { PillProps, Pill } from 'components/Shared'

export interface PillCellProps extends ICellRendererParams, PillProps {}

export const PillCell: FC<PillCellProps> = ({ value, palette }) => {
  return <Pill label={value} palette={palette} />
}
